import { upsertQueryParam } from "common/utils/browser";
import { isIframe } from "common/utils/ui/browser";
import "./products-top-filters.scss";

const $getOutOfStockHandler = () => document.querySelector(".js-products-hide-oos");
const $getSortSelectHandler = () => document.querySelector(".js-products-top-filters__select-box");

const observeScrollToAction = () => {
  const target = localStorage.getItem("scrollTo");
  if (target !== "#products-top-filters") return;

  const $target = document.querySelector(target);
  // if the page is loaded in an iframe, scrollIntoView is working incorrectly
  // cause parent window is modified the page template and we have to wait
  // for the page to be fully builded
  if (!isIframe) {
    $target?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  localStorage.removeItem("scrollTo");
};

const initOutOfStockHandler = () => {
  const $handler = $getOutOfStockHandler();

  $handler?.addEventListener("change", () => {
    localStorage.setItem("scrollTo", "#products-top-filters");

    const { name } = $handler.dataset;
    setTimeout(() => {
      upsertQueryParam(name, `${$handler.value}`);
    }, 400);
  });
};

const initSortSelectHandler = () => {
  const handleSelectChange = e => {
    upsertQueryParam("sort", e.currentTarget.value);
  };

  $getSortSelectHandler()?.addEventListener("change", handleSelectChange);
};

export default () => {
  initSortSelectHandler();
  observeScrollToAction();
  initOutOfStockHandler();
};
